import { supabase } from '@supabaseClient/supabaseClient';

export type IUser = {
  id: string;
  organization_id: string;
  email: string;
  name: string;
  personal_organization_id: string;
};

export class UsersClient {
  static async createUser(user: { id: string; email: string }): Promise<IUser> {
    const { data, error } = await supabase
      .from('users')
      .insert([user])
      .select();
    if (error) {
      throw error;
    }
    return data[0];
  }

  static async getUserById(id: string): Promise<IUser> {
    const { data, error } = await supabase.from('users').select().eq('id', id);
    if (error) {
      throw error;
    }
    return data[0];
  }

  static async UserLoginWithEmailAndPassword(email: string, password: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });
    if (error) {
      throw error;
    }
    return data;
  }

  static async UserLoginWithEmailLink(email: string) {
    const { data, error } = await supabase.auth.signInWithOtp({
      email,
    });

    if (error) {
      throw error;
    }
    return data;
  }

  static async getUsersByOrganization(organization: string) {
    const { data, error } = await supabase
      .from('users')
      .select()
      .eq('organization_id', organization);
    if (error) {
      throw error;
    }
    return data;
  }

  static async updateUserName(id: string, name: string): Promise<IUser> {
    const { data, error } = await supabase
      .from('users')
      .update({ name })
      .eq('id', id)
      .select()
      .single();
    if (error) {
      throw error;
    }
    return data;
  }
}
